import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-how-visual-learning-improves-retention',
  templateUrl: './how-visual-learning-improves-retention.component.html',
  styleUrls: ['./how-visual-learning-improves-retention.component.scss']
})
export class HowVisualLearningImprovesRetentionComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('How Visual Learning Improves Retention & Exam Performance | Virsa');
    this.metaService.updateTag({ name: 'description', content: 'Discover how visual learning improves student retention and exam results. Upgrade your school with Virsa smart classroom solution and interactive flat panels.' });
    this.metaService.updateTag({ name: 'keywords', content: 'Visual learning in education, K-12 smart classroom solutions, Interactive flat panel for schools, Digital classroom India, Virsa smart classroom' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
